import SelectInput from 'components/input-field/SelectInput';
import TextInput from 'components/input-field/TextInput'
import { Form, Formik } from 'formik';
import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { Col, Row } from 'reactstrap';
import Loader from 'components/loader/Loader';
import FileInput from 'components/input-field/FileInput';
import SaveButton from 'components/buttons/SaveButton';
import { DoctorSchema } from './Validation';
import { AddDoctorRes, AddDoctorTodo } from 'redux/slice/admin/doctor/AddDoctor';

class AddDoctorForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            spiner: false,
            values: {
                name: '',
                mobile: '',
                gender: '',
                qualification: '',
                specilization: '',
                experience: '',
                doctorImage: '',
                status: ''
            }
        };
    }

    status_option = [
        { "value": 'Active', "label": "Active" },
        { "value": 'Inactive', "label": "Inactive" }
    ]

    gender_option = [
        { "value": 'Male', "label": "Male" },
        { "value": 'Female', "label": "Female" }
    ]



    handleSubmit = (values) => {
        this.setState({ spiner: true });
        const { dispatch } = this.props;

        let bodyFormData = new FormData();

        bodyFormData.append("company_id", localStorage.getItem('companyId'))
        bodyFormData.append("name", values.name)
        bodyFormData.append("mobile", values.mobile)
        bodyFormData.append("gender", values.gender)
        bodyFormData.append("qualification", values.qualification)
        bodyFormData.append("specilization", values.specilization)
        bodyFormData.append("experience", values.experience)
        bodyFormData.append("status", values.status)
        bodyFormData.append("path", "category")
        bodyFormData.append("doctorImage", values.doctorImage)
        bodyFormData.append("added_by", localStorage.getItem('user_id'))

        dispatch(AddDoctorTodo(bodyFormData)).then(() => this.add_res());

    }


    add_res = () => {
        if (AddDoctorRes?.success) {
            toast.success(AddDoctorRes?.message, { position: "bottom-right" });
            setTimeout(() => {
                this.props.history.push('/admin/doctor-list');
            }, 1500);
            this.setState({ spiner: false });
        } else {
            toast.error(AddDoctorRes?.message, { position: "bottom-right" });
            this.setState({ spiner: false });
        }
    }
    render() {
        return (
            <>
                <div className='form_layout'>
                    {this.state.spiner ?
                        <div className='d-flex justify-content-center p-5'>
                            <Loader />
                        </div> :

                        <Formik
                            initialValues={this.state.values}
                            validationSchema={DoctorSchema}
                            onSubmit={this.handleSubmit}
                        >
                            {({
                                values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                                <Form>
                                    <Row>
                                        <Col xl='4'>
                                            <TextInput
                                                label_name='Doctor Name'
                                                placeholder=''
                                                name='name'
                                                value={values.name || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.name && touched.name ? (<span className='text-danger form_label' >{errors.name}</span>) : null}
                                            />
                                        </Col>
                                        <Col xl='4'>
                                            <TextInput
                                                label_name='Contact Number'
                                                placeholder=''
                                                name='mobile'
                                                value={values.mobile || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.mobile && touched.mobile ? (<span className='text-danger form_label' >{errors.mobile}</span>) : null}
                                            />
                                        </Col>
                                        <Col xl='4'>
                                            <FileInput
                                                name='doctorImage'
                                                label_name={'Doctor Image'}
                                                onBlur={handleBlur}
                                                onChange={(e) => setFieldValue("doctorImage", e.currentTarget.files[0])}
                                                error={errors.doctorImage && touched.doctorImage ? (<span className='text-danger form_label' >{errors.doctorImage}</span>) : null}
                                            />
                                        </Col>
                                        <Col xl='4'>
                                            <TextInput
                                                label_name='Qualification'
                                                placeholder=''
                                                name='qualification'
                                                value={values.qualification || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.qualification && touched.qualification ? (<span className='text-danger form_label' >{errors.qualification}</span>) : null}
                                            />
                                        </Col>
                                        <Col xl='4'>
                                            <TextInput
                                                label_name='Specilization'
                                                placeholder=''
                                                name='specilization'
                                                value={values.specilization || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.specilization && touched.specilization ? (<span className='text-danger form_label' >{errors.specilization}</span>) : null}
                                            />
                                        </Col>
                                        <Col xl='4'>
                                            <TextInput
                                                label_name='Experience'
                                                placeholder=''
                                                name='experience'
                                                value={values.experience || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.experience && touched.experience ? (<span className='text-danger form_label' >{errors.experience}</span>) : null}
                                            />
                                        </Col>
                                        <Col xl='4'>
                                            <SelectInput
                                                closeMenu={true}
                                                label_name='Gender'
                                                disabled={false}
                                                options={this.gender_option}
                                                name='gender'
                                                defaultValue={''}
                                                onChange={(e) =>
                                                    setFieldValue('gender', e.value)
                                                }
                                                onBlur={handleBlur}
                                                error={errors.gender && touched.gender ? (<span className='text-danger form_label' >{errors.gender}</span>) : null} />
                                        </Col>
                                        <Col xl='4'>
                                            <SelectInput
                                                closeMenu={true}
                                                label_name='Status'
                                                disabled={false}
                                                options={this.status_option}
                                                name='status'
                                                defaultValue={''}
                                                onChange={(e) =>
                                                    setFieldValue('status', e.value)
                                                }
                                                onBlur={handleBlur}
                                                error={errors.status && touched.status ? (<span className='text-danger form_label' >{errors.status}</span>) : null} />
                                        </Col>

                                        <Col xl='12' className='d-flex justify-content-end'>
                                            <SaveButton name={'SAVE'} />
                                        </Col>
                                    </Row>
                                </Form>
                            )}
                        </Formik>
                    }
                </div>
                <ToastContainer />
            </>
        )
    }
}
export default connect()(withRouter(AddDoctorForm));
